<template>
  <div
    v-if="atts"
    class="rexer_events__container"
  >
    <filter-component
      :filters="filters"
      :title="atts.title"
      :selection="catidSelection"
      :locations="locations"
      :locations-selection="currentLocationFilter.label"
    />
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="loading"
        class="rexer_events__loading"
      >
        <loading-component
          fill-color="#00ff00"
        />
      </div>
      <div v-if="!loading">
        <content-component
          :events="eventsFiltered"
          :notfound="atts.notfound"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { env } from './helpers/config'
import FilterComponent from './components/Filter.vue'
import ContentComponent from './components/Content.vue'
import LoadingComponent from './components/Loading.vue'

export default {
  name: 'ComponentsEvents',
  components: {
    FilterComponent,
    ContentComponent,
    LoadingComponent
  },
  data () {
    return {
      filters: null,
      catidSelection: '',
      events: null,
      atts: null,
      currentFilter: 'all',
      currentLocationFilter: {
        value: 'all',
        label: 'Standort auswählen'
      },
      loading: true,
      locations: [],
      eventsFiltered: []
    }
  },
  // computed: {
  //   // eventsFiltered () {
  //   //   if (this.currentFilter === 'all') {
  //   //     return this.events
  //   //   } else {
  //   //     return this.events.filter( event => event['events-cat'][0] === this.currentFilter)
  //   //   }
  //   // }
  // },
  mounted () {
    this.$nextTick(() => {
      this.atts = this.$root.atts
    })
    this.initData()
    // console.log(acf.get('location'))
    this.sub = this.$geb.getBus()
      .subscribe(data => {
        switch (data.id) {
          case 'eventFilter':
            this.currentFilter = data.payload.item
            if (data.payload.item === 'all') this.currentLocationFilter = Object.assign({}, { value: 'all', label: 'Standort auswählen' })
            this.filteredHandle(this.events)
            break
          case 'locationFilter':
            this.currentLocationFilter = data.payload.item
            this.filteredHandle(this.events)
            break
        }
        // Do anything you want with 'data'
      })
  },
  destroyed () {
    if (this.sub) {
      this.sub.unsubscribe()
    }
  },
  methods: {
    filteredHandle (events) {
      let { currentFilter, currentLocationFilter } = this
      if (currentFilter === 'all') {
        this.eventsFiltered = events
      } else {
        this.eventsFiltered = events.filter((event) => {
          return event['events-cat'][0] === currentFilter
        })
      }
      if (currentLocationFilter.value !== 'all') {
        this.eventsFiltered = events.filter((event) => event.acf.location_event.value === currentLocationFilter.value)
      }
    },
    initData () {
      this.loading = true
      Promise.all([
        fetch(env.EVENTS_CAT_URL).then(value => value.json()),
        fetch(env.EVENTS_URL).then(value => value.json())
      ]).then(([filters, events]) => {
        this.filters = filters
        this.events = events.sort((a, b) => a.menu_order > b.menu_order) // menu_order

        this.events.forEach(event => {
          if (event.acf.location_event) {
            this.locations.push(event.acf.location_event)
          }
        })
        this.checkFilterHandle()
        this.filteredHandle(events)
        setTimeout(() => { this.loading = false }, 1000)
      }).catch((err) => {
        console.log(err)
      })
    },
    // filterChooseHandle ($evt) {
    //   this.currentFilter = $evt
    // },
    getUrlParameter (variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] === variable) { return pair[1] }
      }
      return (false)
    },
    checkFilterHandle () {
      const param = this.getUrlParameter('catid')
      if (param) {
        this.catidSelection = param
      }
    }
  }
}
</script>

<style lang="scss">
.rexer_events__container {
  /* overflow: hidden; */
  padding-bottom: 2rem;
  margin-bottom: 2rem;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.rexer_events__loading {
  text-align: center;
}
</style>
